<template>
    <text-dialog :value.sync="dialog" :title="starterTitle">
        <slot name="activator" slot="activator"></slot>

        <div slot="content">
            <p>Anzahl Tänzer: {{ starter.dancer_count }}</p>
            <h2>Tänzerliste</h2>
            <span v-for="(dancer, index) in starter.dancers" :key="index">{{ (index+1) + '. ' + dancer.full_name }}<br></span>
        </div>
    </text-dialog>
</template>

<script>
    import TextDialog from '../dialogs/TextDialog';

    export default {
        components: {
            'text-dialog': TextDialog
        },
        props: {
            id: {
                type: Number,
                default: 0
            },
            value: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            dialog: false,
            starter: {
                name: '',
                dancers: []
            }
        }),
        computed: {
            starterTitle() {
                return this.starter.name === '' ? '...' : `Starter "${this.starter.name}"`;
            }
        },
        watch: {
            value() {
                this.dialog = this.value;
            },
            dialog() {
                this.$emit('update:value', this.dialog);
            },
            id() {
                if (this.id > 0) {
                    this.loadStarter();
                }
            }
        },
        methods: {
            loadStarter() {
                this.$set(this, 'starter', {name: '', dancers: []});

                axios.get(`/api/v1/starter_templates/${this.id}`).then(response => {

                    if (!response.data.success) {
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: 'Details konnten nicht abgerufen werden'
                        });
                        return;
                    }

                    this.$set(this, 'starter', response.data.data);

                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            }
        }
    }
</script>